var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.15209 0.659332C1.39578 0.414874 1.79152 0.414253 2.03598 0.657944L6.20915 4.81809C6.26249 4.87117 6.31334 4.88484 6.35068 4.88478C6.38768 4.88472 6.43782 4.87115 6.49032 4.81923L10.5643 0.649045C10.8056 0.402133 11.2012 0.397511 11.4481 0.638724C11.6951 0.879936 11.6997 1.27564 11.4585 1.52255L7.37729 5.70017C6.80078 6.27849 5.90503 6.27982 5.32671 5.70331L1.15348 1.54321C0.909023 1.29952 0.908402 0.903798 1.15209 0.659332Z",
    fill: "#152035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.b467fd92386cc3ca2b26a4d496ccc74d.svg";
export { ForwardRef as ReactComponent };